import React from "react";
import {
  MdOutlineChromeReaderMode,
  MdOutlineLocationOff,
  MdOutlineTune,
} from "react-icons/md";
import CommonModal from "../utils/commonModal";
import { deviceType } from "../../utils/registrationUtils";
import "./LocationAccessDeniedStyle.css";

const LocationAccessDeniedPopup = ({
  isOpen,
  closeModal,
}) => {
  if (!isOpen) return null;

  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const browserVendor = typeof navigator !== "undefined" ? navigator.vendor : "";
  const browserBrands =
    typeof navigator !== "undefined" && navigator.userAgentData?.brands
      ? navigator.userAgentData.brands.map((brand) => brand.brand).join(" ")
      : "";

  // Safari includes "Safari" in the user agent; Chrome/Firefox/Edge on iOS also do,
  // so exclude their browser tokens before showing Safari-specific settings steps.
  const isChromiumBrowser =
    /chrome|chromium|crios|edg|edgios|opr|opera|samsungbrowser/i.test(
      userAgent
    ) || /chrome|chromium|edge|opera|brave/i.test(browserBrands);
  const isSafariBrowser =
    /safari/i.test(userAgent) &&
    /apple/i.test(browserVendor) &&
    !isChromiumBrowser &&
    !/fxios|android/i.test(userAgent);
  const isDesktop = deviceType == "web";

  // Mobile users need OS settings instructions; keep the earlier mobile content intact.
  const mobileSteps = isSafariBrowser
    ? [
        <>
          To enable location access: Go to <strong>Settings</strong> &rarr;{" "}
          <strong>Privacy &amp; Security</strong> &rarr;{" "}
          <strong>Location Services</strong>, make sure Location Services is{" "}
          <strong>On</strong>
        </>,
        <>
          Then tap <strong>Safari Websites</strong> and select{" "}
          <strong>While Using the App</strong> or <strong>Ask Next Time</strong>{" "}
          (depending on your iOS version)
        </>,
      ]
    : [
        <>
          To enable location access: Open  <strong>Settings</strong> &rarr; <strong>Apps</strong> &rarr;{" "}
          <strong>Browser</strong> &rarr; <strong>Permissions</strong> &rarr;{" "}
          <strong>Location</strong>, then select{" "}
          <strong>Allow only while using the app.</strong>
        </>,
        <>
          Also, ensure your device&apos;s <strong>Location</strong> is turned{" "}
          <strong> On.</strong>
        </>,
      ];

  // Desktop users can usually re-enable permission from the browser URL bar.
  const desktopSteps = [
    <>
      Click the{" "}
      <span className="location_access_denied_inline_icon">
        <MdOutlineTune />
      </span>{" "}
      Site Controls icon before the website URL, or the Location icon{" "}
      <span className="location_access_denied_inline_icon">
        <MdOutlineLocationOff />
      </span>{" "}
      to the URL. Then select <strong>Allow.</strong>
    </>,
    <>
      If you don&apos;t see either option, open <strong>Site settings</strong>{" "}
      and change <strong>Location</strong> from <strong>Block</strong> to{" "}
      <strong>Allow.</strong>
    </>,
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      closeModal={closeModal}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      showCloseIcon={false}
      animationDuration={250}
      classNames={{
        root: "location_access_denied_modal_root",
        overlay: "location_access_denied_modal_overlay",
        modal: "location_access_denied_modal",
        modalAnimationIn: "locationAccessDeniedEnter",
        modalAnimationOut: "locationAccessDeniedExit",
      }}
    >
      <section className="location_access_denied_popup">
        <button
          type="button"
          className="location_access_denied_close"
          onClick={closeModal}
          aria-label="Close location access denied popup"
        >
          &times;
        </button>

        <div className="location_access_denied_icon_wrap" aria-hidden="true">
          <MdOutlineLocationOff className="location_access_denied_icon" />
        </div>

        <div className="location_access_denied_title">
          Location Access Denied
        </div>
        <p className="location_access_denied_subtitle">
          Please allow the location to detect your city.
        </p>

        {isDesktop && isSafariBrowser ? (
          <p className="location_access_denied_desktop_message">
            In Safari browser click the{" "}
            <span className="location_access_denied_inline_icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x=".637" y=".636" width="12.727" height="6.363" rx="2.037" stroke="#000" stroke-width="1.222"/>
    <path d="M.637 10.181h12.727M.637 13.363h9.545" stroke="#000" stroke-width="1.273" stroke-linecap="round"/>
</svg>
            </span>{" "}
            Safari Reader icon before the website URL. Then{" "}
            <strong>Website Settings &gt; Location &gt; Allow.</strong>
          </p>
        ) : (
          <ol className="location_access_denied_steps">
            {(isDesktop ? desktopSteps : mobileSteps).map((step, index) => (
              <li key={index}>
                <span className="location_access_denied_step_number">
                  {index + 1}
                </span>
                <span className="location_access_denied_step_text">{step}</span>
              </li>
            ))}
          </ol>
        )}
      </section>
    </CommonModal>
  );
};

export default LocationAccessDeniedPopup;
